import React from "react";
import { useNavigate } from "react-router-dom";
import { AuthService } from "../services/auth.service";
import { ProfileService } from "../services/profile.service";
import MainLayout from "../components/layouts/MainLayout";
import { FinancialHealthWidget } from "../components/dashboard/FinancialHealthWidget";
import { AccountReceivableWidget } from "../components/dashboard/AccountReceivableWidget";
import { PatientAccountReceivableWidget } from "../components/dashboard/PatientAccountReceivableWidget";
import { CurrentARWidget } from "../components/dashboard/CurrentARWidget";
import { ChargesPaymentsWidget } from "../components/dashboard/ChargesPaymentsWidget";
import { ClaimEfficiencyWidget } from "../components/dashboard/ClaimEfficiencyWidget";
import { JCodeARWidget } from "../components/dashboard/JCodeARWidget";
import { hasAccess, ROLES } from "../utils/roles";

export const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const user = AuthService.getCurrentUser();

  if (!user) {
    navigate("/");
    return null;
  }

  const userRoles = ProfileService.getUserProfileFromStorage()?.roles ?? [];
  const dashPageRoles = [ROLES.DASHBOARD_ADMIN, ROLES.DASHBOARD_USER];

  const canFinancialHealth = hasAccess(userRoles, [
    ROLES.DASHBOARD_WIDGET_FINANCIAL_HEALTH,
    ...dashPageRoles,
  ]);
  const canCurrentAR = hasAccess(userRoles, [ROLES.DASHBOARD_WIDGET_CURRENT_AR, ...dashPageRoles]);
  const canChargesPayments = hasAccess(userRoles, [
    ROLES.DASHBOARD_WIDGET_CHARGES_PAYMENTS,
    ...dashPageRoles,
  ]);
  const canPatientAR = hasAccess(userRoles, [ROLES.DASHBOARD_WIDGET_PATIENT_AR, ...dashPageRoles]);
  const canClaimEfficiency = hasAccess(userRoles, [
    ROLES.DASHBOARD_WIDGET_CLAIM_EFFICIENCY,
    ...dashPageRoles,
  ]);
  const canInsuranceAR = hasAccess(userRoles, [
    ROLES.DASHBOARD_WIDGET_INSURANCE_AR,
    ...dashPageRoles,
  ]);
  const canJCodeAR = hasAccess(userRoles, [ROLES.DASHBOARD_WIDGET_JCODE_AR, ...dashPageRoles]);

  return (
    <MainLayout>
      {/* Main Content */}
      <main className="flex-1 min-w-0 relative md:ml-0 ml-12">
        <div className="w-full max-w-none">
          {/* Widgets Grid - Responsive Layout */}
          <div className="p-4 sm:p-6 md:p-8">
            <div className="grid grid-cols-1 min-[1248px]:grid-cols-3 gap-4 sm:gap-6 items-start">
              <div className="space-y-4 sm:space-y-6">
                {canFinancialHealth && <FinancialHealthWidget />}
                {canCurrentAR && <CurrentARWidget />}
              </div>
              <div className="space-y-4 sm:space-y-6">
                {canChargesPayments && <ChargesPaymentsWidget />}
                {canPatientAR && <PatientAccountReceivableWidget />}
              </div>
              <div className="space-y-4 sm:space-y-6">
                {canClaimEfficiency && <ClaimEfficiencyWidget />}
                {canInsuranceAR && <AccountReceivableWidget />}
                {canJCodeAR && <JCodeARWidget />}
              </div>
            </div>
          </div>
        </div>
      </main>
    </MainLayout>
  );
};
